import { render, staticRenderFns } from "./PaymentPushForm.vue?vue&type=template&id=4ff0f9d1&"
import script from "./PaymentPushForm.vue?vue&type=script&lang=js&"
export * from "./PaymentPushForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports